import { WarningState } from '@/frontend/SVGs/WarningState';
import { I18n } from '@/i18n/I18n';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export function ValidationsOverriddenIcon(props: { placement?: 'top' | 'right'}) {
  const { placement } = props;

  return (
    <OverlayTrigger
      placement={placement || 'top'}
      overlay={<Tooltip>
        {I18n.get('validationsOverridden')}
      </Tooltip>}
    >
      <div className='text-warning'>
        <WarningState />
      </div>
    </OverlayTrigger>
  );
}
